export namespace constProcCd {
	export const New = 0;
	export const Saved = 1;
	export const SaveErrorPosca = -10;
	export const SaveErrorCC = -11;
	export const InCart = 2;
	export const InCartErrorPosca = -20;
	export const InCartErrorCC = -21;
	export const InCartDuplicateCC = -22;
	export const ConfirmOrder = 3;
	export const ConfirmOrderError = -3;
	export const Composing = 4;
	export const Done = 5;
	export const Cancel = 9;
	export const CompError = -40;

}

export namespace constDialogMessage{

	/**
	 * INFO系
	 * */
	export const INFO_SAVE_FINISHED = '保存が完了しました。<br>保存した編集データはサイトトップ右上にある<span class="is-emphasized">[保存データから開く]</span>ボタンから開くことができます。';
	export const INFO_ATENA_ORDER_STOP = '宛名印刷の受付は終了しました。';

	/**
	 * ERR系
	 * */
	export const ERROR_SYSTEM = "エラーが発生しました。<br>しばらく経ってから再度お試しください。";
	export const ERROR_IMAGE = "画像が登録できません。";
	export const ERROR_DELETE_IMAGE = "画像が削除できません。";
	export const ERROR_SERVER_ACCESS_TEXT = "通信エラーが発生しました。通信状況の良いところで再度お試しください。";
	export const ERROR_SERVICE_STOPPED_TEXT = "ポストカードはサービス停止中です。年末年始は受付ができない場合がございます。";
	export const ERROR_FILE_NG_TEXT = "画像のアップロードに失敗しました。<br>再度お試しください。<br>※続けて失敗する場合は、画像が壊れている可能性がありますので、編集アプリ等で保存しなおしてから再度お試しください。";
	export const ERROR_IMAGE_FORMAT_TEXT = "プリント注文できない画像フォーマットもしくは画像サイズです。";
	export const ERROR_SESSION_TIME_OUT_TRY_AGAIN_TEXT = "６０分間操作が行われなかったのでタイムアウトが発生しました。再度サイトトップに戻って操作を行なってください。";
	export const ERROR_EDIT_DATA_OVER_MAX_TEXT = "編集中の保存データの数が上限を超えました。<br>保存データを削除してから再度操作を行ってください。";
	export const INFO_HAVE_NOT_SAVE_IMAGE_TEXT = "本サービスで利用できない画像が含まれていました。利用可能な画像のみ候補画像一覧に登録されます。";
	export const ERROR_DESIGN_EXPIRED_TEXT = "ご利用のデザインの有効期限がきれています。<br>別のデザインを選択してください。";
	export const ERROR_DESIGN_PRINTTYPE_INDVALID_TEXT = "ご利用できないデザインが選択されました。<br>別のデザインを選択してください。";

	/** 受付停止メッセージ(通常) */
	export const ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT = "「印刷仕上げ」「写真仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。";
	export const ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT = "「印刷仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。<br>今後のご注文は、「写真仕上げ」となります。";
	export const ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT = "「写真仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。<br>今後のご注文は、「印刷仕上げ」となります。";
	export const ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT_ADDORDER = "「印刷仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。";
	export const ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT_ADDORDER = "「写真仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。";

	/** 受付停止メッセージ(キタムラ) */
	export const ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT_KITAMURA = "「最短１時間仕上げ」「写真キレイ仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。";
	export const ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT_KITAMURA = "「最短１時間仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。<br>今後のご注文は、「写真キレイ仕上げ」となります。";
	export const ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT_KITAMURA = "「写真キレイ仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。<br>今後のご注文は、「最短１時間仕上げ」となります。";
	export const ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT_ADDORDER_KITAMURA = "「最短１時間仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。";
	export const ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT_ADDORDER_KITAMURA = "「写真キレイ仕上げ」の受付を終了いたしました。<br>皆様のご注文誠にありがとうございました。";

	export const ERROR_DATA_EXPIRED_TEXT = "ご利用の編集データの有効期限がきれています。<br>別の編集データを選択してください。";
	export const ERROR_SENDER_INFO_REGIST_TEXT = "差出人情報の登録ができませんでした。<br>環境依存文字（パソコン環境によっては、正しく表示されない文字）が含まれていないかをご確認のうえ、再度登録してください。";
	export const ERROR_DESIGN_FRAME_EXPIRED_TEXT = "ご利用いただきましたデザインフレームの有効期限が切れております。<br>別のデザインフレームをご利用ください。";
	export const ERROR_SERVICE_PAUSE_TEXT = "ポストカードサービスは注文受付を休止しています。<br>ご迷惑おかけいたしますが、受付再開後、ご利用ください。";
	export const ERROR_IMAGE_UPLOAD_OVER_MAX_TEXT = "アップロードされた画像の数が上限数を超えました。<br>保存した画像を削除してから、再度操作を行ってください。";
	export const ERROR_IMAGE_NOT_AVAILABLE_TEXT = "ご利用いただけない画像フォーマットです。";
	export const ERROR_IMAGE_CHECKSUM_TEXT = "ご利用の画像が正しくアップロードされていない可能性があります。<br>再度、アップロードを実行してください。それでも同じエラーが出る場合は、画像の一部が破損している場合があります。";
	export const ERROR_IMAGE_ANALYZER_BASE_TEXT = "ご利用いただけない画像フォーマットもしくは画像サイズです。<br>（詳細）";

	export const ERROR_TRIAL_RETAILER_INVALID = "ご利用のリテーラでは1枚お試し注文を受け付けておりません。";
	export const ERROR_TRIAL_DESIGN_INVALID = "ご指定のデザインでは1枚お試し注文を受け付けておりません。";

	export const ERROR_GET_PREVIEW_TEXT = "プレビュー画像取得に失敗しました。";

	export const ERROR_CC_LOGIN_WITH_GIGYA = "コマースクラウド連携認証(FF)に失敗しました。";
	export const ERROR_CC_LOGIN_CHECK = "コマースクラウドログインチェックに失敗しました。";
	export const ERROR_GIGYA_SIGNATURE_INVALID = "ログイン情報の検証に失敗しました。";
	export const ERROR_GIGYA_ERROR = "ログイン連携に失敗しました。";
	export const ERROR_GIGYA_LOGIN = "ログイン認証に失敗しました(GIGYA)";
	export const ERROR_OCAPI_LOGIN = "ログイン認証に失敗しました(OCAPI)";
	export const ERROR_SAVE_DATA = "保存に失敗しました";

	export const ERROR_LOGIN = "ログイン認証に失敗しました。";
	export const ERROR_LOGIN_CHECK = "ログインチェックに失敗しました。";
	export const ERROR_LOGIN_SESSION_TIMEOUT = "ログイン状態がタイムアウトしました。<br>【OK】ボタンを押下して再度ログインしてください。";

	export const ERROR_GET_SAVETOKEN = "保存用トークン取得に失敗しました。";
	export const ERROR_GET_CARTTOKEN = "カートトークン取得に失敗しました。<br>お手数ですが、再度サイトトップに戻って操作を行なってください。";
	export const ERROR_CHECK_SAVE = "コマースクラウド保存チェックに失敗しました。";
	export const ERROR_SAVE = "コマースクラウド保存に失敗しました。";

	export const ERROR_ADD_CART_CHECK_DUPLICATE = "ショッピングカートに同時購入できない商材があります。</br>カート内の商品を購入するか、クリアしてから再度カート追加してください。";
	export const ERROR_ADD_CART_CHECK = "ショッピングカートに追加できませんでした。";

	export const ERROR_TRANS_ATENA = "宛名印刷遷移に失敗しました。";

	export const ERROR_LOCAL_DB_READ = "indexedDBからの読み込みに失敗しました。";
	export const ERROR_LOCAL_DB_WRITE = "indexedDBからの書き込みに失敗しました。";
	export const ERROR_LOCAL_DB_CONNECT = "indexedDBの接続に失敗しました。";

	export const ERROR_HAGAKI_SELECT = "ハガキ種の選択に失敗しました。";
	export const ERROR_HAGAKINUM_VALIDATION_RANGE = "枚数は10枚～999枚の範囲で入力してください。";
	export const ERROR_HAGAKINUM_VALIDATION_CHARACTER = "枚数は半角数字で入力してください。";

	export const ERROR_ADDORDER_ORDER_NONE = "追加注文可能な注文はありません";

	export const WARNING_PHOTO_LIMIT = "候補画像数が上限に達しています。<br>画像の選択数を減らしてから、再度操作を行ってください。";

	export const WARNING_MULTITAB_FORBIDDEN = "複数タブでの操作は保障していません。<br>1つのタブでご利用ください<br>こちらのタブ画面を閉じてください。";
	//export const ERROR_SESSION_TIMEOUT = "６０分間操作が行われなかったのでタイムアウトが発生しました。<br>再度サイトトップに戻って操作を行なってください。";


	export const INFO_EDIT_NEXTPAGE_CHECK = "以下の項目が入力されていません。<br>このまま仕上がりイメージ確認画面に進んでもよろしいですか？";
	export const INFO_EDIT_DEL_PHOTO_CHECK = "選択した画像は、編集画面で利用中です。<br>削除してもよろしいですか。";
	export const INFO_EDIT_EXISTS_WILDCARDCHAR = "●が残っています、よろしいでしょうか？";
	export const INFO_EDIT_EXISTS_WILDCARDCHAR2 = "■が残っています、よろしいでしょうか？";


	export const ERROR_EDIT_CHANGE_MODE = "モード切替に失敗しました";
	export const ERROR_EDIT_DEL_PHOTO = "画像の削除に失敗しました";
	export const ERROR_EDIT_SWAP_PHOTO = "画像の入替に失敗しました";
	export const ERROR_EDIT_DL_PHOTO_THUMBNAIL = "サムネイルのダウンロードに失敗しました";
	export const ERROR_EDIT_CREATE_GREETING = "あいさつ文の作成に失敗しました。";
	export const ERROR_EDIT_CREATE_SENDER = "差出人の作成に失敗しました。";
	export const ERROR_EDIT_DEL_SENDER = "差出人の削除に失敗しました。";
	export const ERROR_EDIT_CREATE_STAMP = "スタンプの追加に失敗しました。";
	export const ERROR_EDIT_DEL_STAMP = "スタンプの削除に失敗しました。";
	export const ERROR_EDIT_ROLLBACK = "操作の取り消しに失敗しました。";
	export const ERROR_EDIT_EDIT_CLEAR = "編集の初期化に失敗しました。";
	export const ERROR_EDIT_REMOVE_PHOTO = "フレームから削除に失敗しました。";
	export const ERROR_EDIT_MOVE_PHOTO = "画像の移動に失敗しました。";
	export const ERROR_EDIT_SCALEUP_PHOTO = "画像の拡大に失敗しました。";
	export const ERROR_EDIT_SCALEDOWN_PHOTO = "画像の縮小に失敗しました。";
	export const ERROR_EDIT_ROTATE_PHOTO = "画像の回転に失敗しました。";
	export const ERROR_EDIT_SET_PHOTO = "画像の適用に失敗しました。";
	export const ERROR_EDIT_CREATE_MYSTAMP = "写真スタンプの追加に失敗しました。";
	export const ERROR_EDIT_DEL_MYSTAMP = "写真スタンプの削除に失敗しました";
	export const ERROR_EDIT_CREATE_TEGAKISTAMP = "手書きの追加に失敗しました。";
	export const ERROR_EDIT_DEL_TEGAKISTAMP = "手書きの削除に失敗しました";
	export const ERROR_EDIT_CHANGE_TEGAKISTAMP = "手書きの色変更に失敗しました";
	export const ERROR_EDIT_CHECKUPLOADIMAGES = "アップロード画像存在チェックに失敗しました";

	export const WARN_EDIT_PHOTO_FORMAT_CHECK = "ご利用いただけない画像フォーマットです。";
	export const WARN_EDIT_PHOTO_SIZE_CHECK = "ファイルサイズが50MBを超えています。<br>サイズを調整してからアップロードしてください。";
	export const WARN_EDIT_NOSEL_GREETING_SAMPLE = "例文を選択してください。";
	export const WARN_EDIT_GREETING_MAX_NUM = "あいさつ文数が上限に達しています。<br>編集画面であいさつ文を削除してから再操作ください。";
	export const WARN_EDIT_INPUT_CHECK = "入力された項目にエラーがあります。";
	export const WARN_EDIT_INPUT_CHECK_FONTSIZE = "文字サイズを入力してください。";
	export const WARN_EDIT_FORMAT_CHECK_FONTSIZE = "文字サイズは[整数部4桁、小数部2桁]の形式で入力してください。";
	export const WARN_EDIT_INPUT_CHECK_CHARCOLOR = "文字色を選択してください。";
	export const WARN_EDIT_INPUT_CHECK_OUTCHARCOLOR = "フチ文字色を選択してください。";
	export const WARN_EDIT_INPUT_CHECK_TEXT = "文章入力欄に文字が入力されていません。<br>文字を入力して下さい。";
	export const WARN_EDIT_CHECK_GREETINGTEXT = "あいさつ文に入力できる文字数は全角400文字以内/半角800文字以内です。";
	export const WARN_EDIT_CHECK_FREESENDERTEXT = "差出人情報欄に入力できる文字数は全角400文字以内/半角800文字以内です。";
	export const WARN_EDIT_INPUT_CHECK_SENDERTEXT = "差出人情報欄に文字が入力されていません。<br>文字を入力して下さい。";
	export const WARN_EDIT_CHARNUM_CHECK_SENDERTEXT = "1行に入力できる文字数は全角16文字以内/半角32文字以内です。<br>10行まで入力できます。";
	export const WARN_EDIT_FORMAT_CHECK_ZIP1 = "3文字以内で入力してください。";
	export const WARN_EDIT_FORMAT_CHECK_ZIP2 = "4文字以内で入力してください。";
	export const WARN_EDIT_FORMAT_CHECK_ADDRESS = "全角40文字、半角80文字以内です。";
	export const WARN_EDIT_FORMAT_CHECK_TEL = "電話番号は半角数字で入力してください。";
	export const WARN_EDIT_FORMAT_CHECK_LEN_TEL1 = "6文字以内で入力してください。";
	export const WARN_EDIT_FORMAT_CHECK_LEN_TEL2 = "4文字以内で入力してください。";
	export const WARN_EDIT_FORMAT_CHECK_LEN_TEL3 = "4文字以内で入力してください。";
	export const WARN_EDIT_FORMAT_CHECK_NAME = "全角13文字、半角26文字以内です。";
	export const WARN_EDIT_FORMAT_CHECK_RUBI = "全角20文字、半角40文字以内です。";
	export const WARN_EDIT_FORMAT_CHECK_PS = "全角20文字、半角40文字以内です。";
	export const WARN_EDIT_FORMAT_CHECK_TITLE = "全角32文字、半角64文字以内です。";
	export const WARN_EDIT_FORMAT_CHECK_EMAIL = "半角128文字以内です。";
	export const WARN_EDIT_FORMAT_CHECK_CORPNAME = "全角32文字、半角64文字以内です。";
	export const WARN_EDIT_FORMAT_CHECK_CORPBUSYO = "全角32文字、半角64文字以内です。";
	export const WARN_EDIT_EMPTY_CHECK = "が入力されていません。";
	export const WARN_EDIT_RELATION_CHECK = "正しく入力してください。";
	export const WARN_EDIT_HALF_NUMBER_CHECK = "半角数字のみ入力してください。";
	export const WARN_EDIT_BASE = "入力された項目にエラーがあります。<br>入力内容をご確認のうえ、OKボタンを押してください。<br>";
	export const WARN_EDIT_CHECKUPLOADIMAGES = "アップロードされた画像が存在しません。<br>お手数ですが画像アップロードからやり直してください。";

	export const WARN_EDIT_CHECK_SONBP_UPLOADIMAGES_DIFF = "使用中の画像とアップロードした画像が一致しません。<br>画像一覧から画像を選択して画像枠に再配置してください。";
	export const WARN_EDIT_CHECK_SONBP_UPLOADMYSTAMPS_DIFF = "使用中の写真スタンプとアップロードした写真スタンプが一致しません。<br>写真スタンプ一覧から写真スタンプを再配置してください。";
	export const WARN_EDIT_CHECK_SONBP_UPLOADTEGAKISTAMPS_DIFF = "使用中の手書きスタンプとアップロードした手書きスタンプが一致しません。<br>手書き一覧から手書きスタンプを再配置してください。";

	export const WARN_GAIJI_NOT_SUPPORT_FONT = "選択されたフォントは外字対応しておりません。<br>外字が使用できるフォントは「楷書体」「行書体」「丸ゴシック体」です。";
	

}

